import { Component, Inject, OnInit, Renderer2 } from "@angular/core";
import { NavService } from "../../services/nav.service";
import { LayoutService } from "../../services/layout.service";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { StorageService } from "../../services/storage.service";
import { LayoutDetails, User } from "../../../auth/auth.model";
import { Subscription } from "rxjs";
import { SendDataService } from "../../services/send-data.service";
import { CommonService } from "../../services/common.service";
import { Router } from "@angular/router";
import { EditProfileService } from "../../../auth/onboarding/edit-profile/edit-profile.service";
import { CustomerOrderSummary } from "../../models/common.model";
import { IconHover, ImplementedOn, StorageName } from "../../enum/common-enum";
import { MaximizeToggleService } from "../../services/maximize-toggle-service.service";
import { WeightMachineService } from "../../services/weight-machine.service";
import { SettingTab } from "../../../components/settings/set-software/set-software.model";
import { NotificationService } from "../../services/notification.service";
import { DOCUMENT } from "@angular/common";
import { SettingsService } from "../../../components/settings/settings.service";
import { ToastrService } from "ngx-toastr";

SwiperCore.use([Navigation, Pagination, Autoplay]);
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent extends CommonService implements OnInit {
  @Inject(DOCUMENT) private document: any;
  isWhatsappConnected: boolean = false;
  isSingleClick: Boolean = true; 
  currentHoverEffect = IconHover.Pink
  public elem: any;
  user:User;
  isRateVisible: boolean = false;
  layoutDetails:LayoutDetails;
  private branchSubscription:Subscription;
  private cartDetailsSubscription:Subscription;
  private refreshCompanyDetailsSubscription:Subscription;
  private whatsappConnectionSubscription:Subscription;
  cartDetails

  constructor(public layout: LayoutService, 
    public navServices: NavService, 
    public storageservice: StorageService,
    public layoutService: LayoutService,
    public renderer : Renderer2,
    public router : Router,
    public editProfileService : EditProfileService,
    private sendDataService: SendDataService,
    public weightMachineService: WeightMachineService,
    public maximizeToggleService:MaximizeToggleService,
    public notificationService : NotificationService,
    public settingsService : SettingsService,
    public toaster : ToastrService) {
    super(renderer);
    
  }

  ngOnInit() {
    this.branchSubscription = this.sendDataService.ShowUserDetails.subscribe((res => {
      if (res) {
        this.setDetails();
      }
    }));
    this.elem = document.documentElement;
    this.setDetails();

    this.refreshCompanyDetailsSubscription = this.editProfileService.refreshCompanyDetails.subscribe((res => {
      if (res) this.layoutDetails = this.storageservice.retrieve(StorageName.LAYOUT_DETAILS);
    }));

    this.getCartDetails();
    this.cartDetailsSubscription = this.sendDataService.updateCart.subscribe((res => {
      if (res) {
        this.getCartDetails();
      }
    }));
    this.whatsappConnectionSubscription = this.sendDataService.whatsappConnectionStatus.subscribe((res => {
      if (res) {
        this.isWhatsappConnected = res == 'CONNECTED';
      }
    }));
  }

  handleImageError(event: any) {
    event.target.src = this.layoutService?.displayDefaultCompanyIcon;
  }
  
  getCartDetails(){
        const customersOrderSummary =  this.storageservice.retrieve(CustomerOrderSummary);
        const customerId = this.user?.accountLedgerId ? this.user?.id :undefined;
        this.cartDetails =  customersOrderSummary?.find(x=>x?.customerId == customerId);  
  }

  navigateProductCheckout(){
    this.router.navigate(["inventory/jewelry-Catalogue/product-Checkout"])
  }

  setDetails(){
    this.user =this.storageservice.retrieve('user');
    this.layoutDetails =this.storageservice.retrieve(StorageName.LAYOUT_DETAILS);
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    this.navServices.megaMenu = false;
    this.navServices.levelMenu = false;
  }

  layoutToggle() {
    if ((this.layout.config.settings.layout_version = "dark-only")) {
      document.body.classList.toggle("dark-only");
    }
    document.body.remove;
  }

  searchToggle() {
    this.navServices.search = true;
  }

  languageToggle() {
    this.navServices.language = !this.navServices.language;
  }

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    this.maximizeToggleService.setHeaderFlag(true);
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  navgateToDashboard(){
    this.router.navigate(['/dashboard']);
  }

  openUpdateRateToggler(){
    this.isRateVisible = !this.isRateVisible; 
  }

  //#region clear cache confirmation popup

  openClearCacheConfirmationPopup() {
    this.notificationService.confirmationPopup('Clear Cache', `Do You Want To Clear The Cache?`, 'confirm-clear-cache', true, 'Yes', `No`, false).subscribe((result) => {
      if (result?.isConfirmed) {
        this?.clearCache();
      }
    });
  }
  clearCache() {
    this.storageservice.clear();
    window.location.reload();
  }
  //#endregion

  ngOnDestroy(){
    this.branchSubscription?.unsubscribe();
    this.cartDetailsSubscription?.unsubscribe();
    this.refreshCompanyDetailsSubscription?.unsubscribe();
    this.whatsappConnectionSubscription?.unsubscribe();
  }

  navigateToCredentials() {
    this.storageservice.store(StorageName.SET_SOFTWARE_ACTIVE_TAB_ID,SettingTab.NotificationConfiguration.toString());
    this.router.navigate(['/settings/set-software']);

    // this.storageService.sendWhatsappImg.next(undefined);
    this.sendDataService.navigateToCrdentialWhatsapp.next(true);
  }

//#region for Device Icon Functionality

 checkWeightMachineData(){    //for checking if there is any data in device component regarding weight machine
  const apiRequestModel = this.storageservice.retrieve(StorageName.APIREQUEST_SETTINGS_SET_SOFTWARE_DEVICES_SERIESLIST_GRID) || {};
  this.settingsService.getAllDevice(apiRequestModel).subscribe({
    next: (res)=>{
      if(res?.response){
        this.storageservice?.store(StorageName.WEIGHT_MACHINE_SETTING_DATA,res?.response);
        this?.weightMachineService?.connect()
      }
    }})
 }

  navigateToDevice() {
    this.storageservice.store(StorageName.SET_SOFTWARE_ACTIVE_TAB_ID,SettingTab.Devices.toString());
    this.router.navigate(['/settings/set-software']);
    this.sendDataService.navigateDeviceWeightMachine.next(true);
  }

 forSingleClick(){
  this.isSingleClick = true;
    setTimeout(()=>{
        if(this.isSingleClick){
          this?.navigateToDevice();
        }
    },250)
  }

  forDblClick(){
    this.isSingleClick = false;
    if(this?.weightMachineService.isMachineConnected){
      this?.openDisconnectMachineConfirmation();
    }
  }

  openDisconnectMachineConfirmation() {
    this.notificationService.confirmationPopup('Serial Port', `Do You Want To Disconnect The Port?`, 'connect-cabel', true, 'Yes', `No`, false).subscribe((result) => {
      if (result?.isConfirmed) {
        this?.weightMachineService?.disconnect()
      }
    });
  }

//#endregion for Device Icon end.
}
